import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.element.dataset.action = `click->${this.element.dataset.controller}#trigger`;
  }

  trigger() {
    const selection = window.getSelection();
    if (selection.type === 'Range') {
      return;
    }
    this.tab.click();
    this.otherParents.collapse('hide');
    this.parent.collapse('show');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get selector() {
    return this.data.get('target');
  }

  get tabSelector() {
    return `${this.selector}-tab`;
  }

  get tab() {
    return $(this.tabSelector);
  }

  get content() {
    return $(this.selector);
  }

  get parent() {
    return this.content.closest('.collapse');
  }

  get otherParents() {
    return $('.collapse').not(this.parent);
  }
}
